import {
  Button,
  ChevronDownIcon,
  Dialog,
  DropdownMenu,
  Flex,
  Checkbox,
  useIsMobileScreenSize,
  ExternalLinkIcon,
} from '@buffer-mono/popcorn'

import styles from './Footer.module.css'

import type { IBlueskyAuthFooter } from '../../types'

import type { JSX } from 'react'

export function Footer({
  loading,
  isRefreshingChannelConnection,
  blueskyData,
  setBlueskyData,
}: IBlueskyAuthFooter): JSX.Element {
  const notValidForSubmit = !blueskyData?.handle || !blueskyData?.appPassword
  const isMobile = useIsMobileScreenSize()

  const followUsText = isMobile ? 'Follow us' : 'Follow us on Bluesky'

  return (
    <Flex direction="column" align="baseline" className={styles.wrapper}>
      <Dialog.Footer className={styles.footer}>
        <DropdownMenu className={styles.helpMenu}>
          <DropdownMenu.Trigger>
            <Button
              variant="tertiary"
              size="large"
              className={styles.helpButton}
            >
              Need Help
              <ChevronDownIcon />
            </Button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content align="start">
            <DropdownMenu.Item>
              <a
                className={styles.helpLink}
                href="https://support.buffer.com/articles/using-bluesky-with-buffer-7f6OcRnzIO"
                target="_blank"
                rel="noopener noreferrer"
              >
                Using Bluesky with Buffer
                <ExternalLinkIcon />
              </a>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu>
        <Flex align="center" gap="sm" className={styles.followUsContainer}>
          {!isRefreshingChannelConnection && (
            <Checkbox
              id="followbuffer"
              defaultChecked
              checked={blueskyData?.followBuffer}
              onChange={(checked): void => {
                setBlueskyData({
                  ...blueskyData,
                  followBuffer: checked === true,
                })
              }}
            >
              {followUsText}
            </Checkbox>
          )}
          <Button size="large" disabled={loading || notValidForSubmit}>
            {loading ? 'Connecting Channel' : 'Continue'}
          </Button>
        </Flex>
      </Dialog.Footer>
    </Flex>
  )
}
